export namespace DataTestId {
  export const userMenu = "user-menu"
  export const userMenuLogout = `${userMenu}-logout`

  export const storyCarouselRoot = "story-carousel-root"
  export const storyCarouselStory = "story-carousel-story"
  export const storyCarouselProgressBarList = "story-carousel-progress-bar-list"
  export const storyCarouselProgressBar = "story-carousel-progress-bar"
}
